import * as THREE from 'three'

import { createQuantitySprite, updateQuantitySprite } from './InteractionTile.js'

export default class InventoryIndicator
{
    constructor(_options)
    {
        this.time = _options.time
        this.factory = _options.factory
        this.container = new THREE.Group()
        this.container.visible = false
        this.entries = new Map()
        this.lastInput = 0
        this.opacity = 0
        this.holdDuration = 1800
        this.fadeDuration = 700
    }

    add(_resource, _total)
    {
        let entry = this.entries.get(_resource)
        if(!entry)
        {
            const group = new THREE.Group()
            const item = this.factory.createItem(_resource, 1.35)
            item.position.set(-0.28, 0, 0)
            const quantity = createQuantitySprite()
            quantity.position.set(0.42, 0, 0.12)
            group.add(item, quantity)
            this.container.add(group)

            const materials = []
            group.traverse((_child) =>
            {
                if(!_child.isMesh && !_child.isSprite)
                    return
                const sourceMaterials = Array.isArray(_child.material) ? _child.material : [_child.material]
                const clonedMaterials = sourceMaterials.map((_material) =>
                {
                    const material = _material.clone()
                    material.transparent = true
                    materials.push({
                        material,
                        opacity: material.uniforms?.opacity?.value ?? material.opacity,
                        alpha: material.uniforms?.uAlpha?.value
                    })
                    return material
                })
                _child.material = Array.isArray(_child.material) ? clonedMaterials : clonedMaterials[0]
            })
            entry = { group, item, quantity, materials, count: 0, offset: this.entries.size * 1.8 }
            this.entries.set(_resource, entry)
        }

        entry.count = _total
        entry.group.visible = true
        updateQuantitySprite(entry.quantity, entry.count)
        this.lastInput = this.time.elapsed
        this.opacity = 1
        this.container.visible = true
        this.setOpacity()
        this.layout()
    }

    layout()
    {
        const visibleEntries = [...this.entries.values()].filter((_entry) => _entry.group.visible)
        visibleEntries.forEach((_entry, _index) =>
        {
            _entry.group.position.x = (_index - (visibleEntries.length - 1) * 0.5) * 1.25
        })
    }

    setOpacity()
    {
        for(const entry of this.entries.values())
        {
            for(const { material, opacity, alpha } of entry.materials)
            {
                if(material.uniforms?.uAlpha)
                    material.uniforms.uAlpha.value = alpha * this.opacity
                else if(material.uniforms?.opacity)
                    material.uniforms.opacity.value = opacity * this.opacity
                else
                    material.opacity = opacity * this.opacity
            }
        }
    }

    update(_position)
    {
        if(!this.container.visible)
            return

        this.container.position.set(_position.x, _position.y, 2.75)
        for(const entry of this.entries.values())
        {
            if(!entry.group.visible)
                continue
            entry.item.position.z = Math.sin(this.time.elapsed * 0.004 + entry.offset) * 0.1
            entry.item.rotation.z = Math.sin(this.time.elapsed * 0.0025 + entry.offset) * 0.06
        }

        const fadeProgress = THREE.MathUtils.clamp((this.time.elapsed - this.lastInput - this.holdDuration) / this.fadeDuration, 0, 1)
        this.opacity = 1 - fadeProgress
        this.setOpacity()
        if(this.opacity > 0)
            return

        this.container.visible = false
        for(const entry of this.entries.values())
        {
            entry.count = 0
            entry.group.visible = false
        }
    }
}
